import './assets/css/vendor/bootstrap.min.css'
// import './assets/css/vendor/bootstrap.rtl.only.min.css'
// import './assets/css/vendor/dore.light.purple.min.css'
// import 'react-perfect-scrollbar/dist/css/styles.css'
// import 'react-table/react-table.css'
// import chatBot from './helpers/Chatbot'

import {
  defaultColor, themeColorStorageKey, isDarkSwitchActive
} from './constants/defaultValues'

const color = isDarkSwitchActive && localStorage.getItem(themeColorStorageKey)
  ? localStorage.getItem(themeColorStorageKey)
  : defaultColor

localStorage.setItem(themeColorStorageKey, color)

const render = () => {
  import(`./assets/css/sass/themes/gogo.${color}.scss`).then(() => {
    // chatBot()
    require('./AppRenderer')
  })
}
render()
